import { createIcon } from '@chakra-ui/icons';

export const CommentCompact = createIcon({
  displayName: 'CommentCompact',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3752 12.25H0.875167C0.175167 12.25 -0.262333 11.4625 0.175167 10.85L2.62517 7.6125V2.625C2.62517 1.1375 3.76267 0 5.25017 0H11.3752C12.8627 0 14.0002 1.1375 14.0002 2.625V9.625C14.0002 11.1125 12.8627 12.25 11.3752 12.25ZM2.62517 10.5H11.3752C11.9002 10.5 12.2502 10.15 12.2502 9.625V2.625C12.2502 2.1 11.9002 1.75 11.3752 1.75H5.25017C4.72517 1.75 4.37517 2.1 4.37517 2.625V7.875C4.37517 8.05 4.28767 8.225 4.20017 8.4L2.62517 10.5Z"
        fill="currentColor"
      />
      <path d="M10.5002 3.5H6.12524V5.25H10.5002V3.5Z" fill="currentColor" />
      <path d="M10.5002 7H6.12524V8.75H10.5002V7Z" fill="currentColor" />
    </svg>,
  ],
});
